import type {ConnectElementConfig} from '../ConnectElementList';

export const capitalSchemeParameter = 'capital-scheme' as const;
export const presentationModeParameter = 'presentation-mode' as const;

export const CapitalFinancingManualPaymentConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "capitalFinancingManualPayment" */
      '../../../components/Capital/CapitalFinancingManualPayment/CapitalFinancingManualPayment'
    ),
  htmlAttributes: {
    [presentationModeParameter]: {
      isInternal: false,
    },
    [capitalSchemeParameter]: {
      isInternal: true,
    },
  },
  htmlEvents: ['onmanualpaymentsubmitted', 'onoverlayclosed'],
  customHtmlElementMethods: {
    setPresentationMode: {
      type: 'AttributeSettingMethod',
      attribute: presentationModeParameter,
      isInternal: false,
      description:
        'Sets the presentation mode. Valid options are "inline" (default) or "overlay".',
    },
    setCapitalScheme: {
      type: 'AttributeSettingMethod',
      attribute: capitalSchemeParameter,
      isInternal: true,
      description:
        'Sets the CapitalScheme value, used to indiciate which capital surface the component is rendering in. Defaults to "EMBEDDED"',
    },
    setOnManualPaymentSubmitted: {
      type: 'EventListenerMethod',
      event: 'onmanualpaymentsubmitted',
      isInternal: false,
      description:
        'Sets the event listener for when a manual payment is submitted.',
    },
    setOnOverlayClosed: {
      type: 'EventListenerMethod',
      event: 'onoverlayclosed',
      isInternal: false,
      description:
        'Sets the event listener for when the overlay is closed in overlay mode.',
    },
  },
  releaseState: 'internal',
  sentryTeam: 'capital_for_platforms',
  teamOwner: 'capital-for-platforms',
  description:
    'Allows connected accounts to make manual payments toward active Capital financings.',
  friendlyName: 'Capital Financing Manual Payment',
};
